import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SomaJourney from "./components/SomaJourney";
import CafeJourneyPage from "./pages/CafeJourneyPage";
import CafeSignupPage from "./pages/CafeSignupPage";
import CafeLoginPage from "./pages/CafeLoginPage";
import CafeDashboardPage from "./pages/CafeDashboardPage";
import StyleLabPage from "./pages/StyleLabPage";
import AdminFeedbackPage from "./pages/AdminFeedbackPage";
import AdminCafesPage from "./pages/AdminCafesPage";
import BeginPage from "./pages/BeginPage";
import { CafeAuthProvider } from "./auth/CafeAuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CafeAuthProvider>
          <Routes>
            <Route path="/" element={<SomaJourney />} />
            <Route path="/begin" element={<BeginPage />} />
            <Route path="/c/:slug" element={<CafeJourneyPage />} />
            <Route path="/cafe/signup" element={<CafeSignupPage />} />
            <Route path="/join" element={<CafeSignupPage />} />
            <Route path="/cafe/login" element={<CafeLoginPage />} />
            <Route path="/cafe/dashboard" element={<CafeDashboardPage />} />
            <Route path="/style-lab" element={<StyleLabPage />} />
            <Route path="/admin/feedback" element={<AdminFeedbackPage />} />
            <Route path="/admin/cafes" element={<AdminCafesPage />} />
          </Routes>
        </CafeAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
